module.exports = __webpack_public_path__ + "img/hipercard.dac55273.png";